<template>
    <el-dialog title="账户充值" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
        <div class="warp-block">
           <div class="block" v-for="(item,index) in listTitle">
              <span>{{item.title}}</span>
              <span>{{item.value}}</span>
           </div>  
        </div>

        <div class="common-items-center">
            <span>充值类型：</span>
            <el-select v-model="payType" placeholder="请选择" size="small">
                <el-option   label="线下充值" :value="4"></el-option>
                <el-option   label="赠送" :value="5"></el-option>
            </el-select>
         </div>
         <div class="common-items-center">
            <span>充值金额：</span>
            <el-input v-model="rechargeAmount" style="width:215px;margin-top: 10px;" size="small" onblur="this.value= !this.value ? 100:this.value"  onkeyup="this.value= this.value.match(/\d+(\.\d{1,2})?/) ? this.value.match(/\d+(\.\d{1,2})?/)[0] : ''" placeholder="请输入充值金额"></el-input>
         </div> 
         <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitBtn">确 定</el-button>
        </div> 
    </el-dialog>
</template>
<script>
import { postFun,httpImg,exportFun } from '@/utils/httpFun'
import {url,api,operate} from '@/utils/config'
export default {
    data:()=>({
        dialogVisible:false,
        listTitle:[],
        payType:4,
        rechargeAmount:100
    }),
    mounted(){

    },
    methods:{
        openBtn(ev){
            console.log(ev)
            this.belongToId = ev.belongToId
            this.belongToType = ev.belongToType
            let parms = {
                belongToId:ev.belongToId,
                belongToType:ev.belongToType,
            }
            postFun(api.Operate+"/financeManager/getAccountDetails",parms,res=>{
                this.listTitle = [
                    {title:"账户ID：",value:res.data.belongToId},
                    {title:"账号：",value:res.data.account},
                    {title:"账户名称：",value:res.data.belongToName},
                    {title:"创建时间：",value:res.data.createTime},
                    {title:"赠送余额：",value:res.data.giveBalance+"元"},
                    {title:"钱包余额：",value:res.data.walletBalance+"元"},
                ]
                this.dialogVisible = true
            })
        },
        //充值提交
        submitBtn(){
            let parms = {
                belongToId:this.belongToId,
                belongToType:this.belongToType,
                payType:this.payType,
                rechargeAmount:this.rechargeAmount
            }
            let urls = this.payType==4 ? api.Operate+"/rechargeManager/offlineRecharge" : api.Operate+"/rechargeManager/giveAmount"
            postFun(urls,parms,res=>{
                if(res.data.result){
                    this.$emit("resetBtn") 
                    this.handleClose()
                }
            })
        },
        handleClose(){
            this.dialogVisible = false
        }  
    }
}
</script>
<style scoped >
  .warp-block{
    display: flex;
    flex-wrap: wrap;
  }
  .block{
     width: 50%;
     margin-bottom: 10px;
  }
  .titleT{
     font-size: 16px;
     font-weight: 700;
  }
</style>